module.exports = __webpack_public_path__ + "static/media/5.7_preview.743f5d28.png";